export function urlify(inputText: string) {
  const pattern1 =
    /(\b(https?|ftp|file):[-A-Z0-9+&@#%?=~_|!:,.;]*[-A-Z0-9+&@#%=~_|])/gi;
  const str1 = inputText.replace(pattern1, "<a href='$1'>$1</a>");

  const pattern2 = /(^|[^])(www\.[\S]+(\b|$))/gim;
  const str2 = str1.replace(
    pattern2,
    '$1<a target="_blank" href="http://$2">$2</a>'
  );
  return str2;
}

export function checkURL(url: string) {
  return url.match(/\.(jpeg|jpg|gif|png)$/) != null;
}
export function checkPDF(url) {
  return url.indexOf(".pdf") !== -1;
}
export function checkIframe(string) {
  return (
    string.match(
      /^<iframe?.*src=('|")(https|http):(\/\/www\.youtube\.com\/|\/\/www\.lynda\.com\/)?.*<\/iframe>/g
    ) != null
  );
}

export function isAnchor(str: string) {
  if (str.indexOf("href") > -1 && str.indexOf("</a>") > -1) {
    return true;
  } else {
    return false;
  }
}

export function getLocaltime() {
  return new Date().toLocaleTimeString([], {
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  });
}
